import { createRequestActionsFor } from "./apiFetch";

export const ORDER_SEND = createRequestActionsFor("ORDER_SEND");
export const ORDER_SEND_CACHED = "ORDER_SEND_CACHED";
export const ORDER_SEND_CLEAR = "ORDER_SEND_CLEAR";
